<template>
  <div :class="serviceBackStyle + ' pb-4'" @mouseleave="$emit('cardComponent', serviceComponent)">
    <div class="service-media">
      <v-icon class="service-icon">monetization_on</v-icon>
    </div>
    <h3 class="display-1 mb-3 text-xs-center">Paquetes</h3>
    <v-card-text class="py-4">
      <ul>
        <li v-for="(pack, i) in webPackage" :key="i" class="tile-custom">
          {{ pack.title }} - <v-icon>monetization_on</v-icon> {{ pack.price }} Ars
        </li>
      </ul>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn outline color="purple darken-1 mt-5" @click.stop="$emit('dialog', true)">Mas informacion</v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </div>
</template>

<script>
export default {
  props: ['serviceBackStyle', 'serviceComponent'],
   data () {
    return {
      webPackage: [
        {title: 'Basico', price: 1000},
        {title: 'Profesional', price: 2500},
        {title: 'Plus', price: 4000},
      ]
    }
  }
}
</script>

<style scoped>

.web-back-service {
  margin-top: -80px;
}

.service-media {
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
}

.service-icon {
  color: #E1BEE7;
  font-size: 10em;
}

.tile-custom {
  text-align: center;
  font-size: 1.2em;
  padding: 10px 0;
  list-style: none;
}

@media screen and (max-width: 780px) {
  .web-back-service {
    margin-top: -60px;
    margin-left: 40px;
  }

  .service-icon {
    font-size: 6em;
  }

}


</style>



// WEBPACK FOOTER //
// src/components/sections/service_cards/WebBackServiceCard.vue